<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <v-container>
        <v-row align="center" justify="center">
            <v-col xs="12" sm="3">
                <v-card>
                    <v-card-title>
                        <span class="headline" align="center" style="color:#FFFD00;background-color:#000000;width:100%;display:block;">Change Password</span>
                    </v-card-title>
                    <v-card-text>
                        <ValidationObserver ref="observer" v-slot="{ invalid }">
                            <v-form>
                                <ValidationProvider
                                    mode="aggressive"
                                    rules="requiredPassword|minPassword:6"
                                    :debounce="300"
                                    v-slot="{ errors }">
                                    <v-text-field
                                    type="password"
                                    name="password"
                                    :error-messages=errors[0]
                                    label="Password"
                                    v-model="form.password"
                                    solo
                                    :disabled="submitting"/>
                                </ValidationProvider>
                                <v-btn
                                    type="submit"
                                    block
                                    large
                                    class="mb-3 primary"
                                    @click="submit()"
                                    :disabled="invalid || submitting">SAVE</v-btn>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { required, min } from 'vee-validate/dist/rules';
    import { updatePassword } from '@/firebase/firebase';
    import { mapMutations } from 'vuex';

    extend('requiredPassword',
    {
        ...required,
        message: 'The password is required and must be at least 6 characters.'
    });
    extend('minPassword',
    {
        ...min,
        message: 'The password is required and must be at least 6 characters.'
    });

    export default
    {
        name: 'change-password-tab',
        components:
        {
            ValidationProvider,
            ValidationObserver
        },
        data()
        {
            return {
                submitting: false,
                form:
                {
                    password: ''
                }
            }
        },
        methods:
        {
            ...mapMutations('common', ['SHOW_SNACKBAR_SUCCESS', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async submit()
            {
                try
                {
                    if (await this.$refs.observer.validate())
                    {
                        this.submitting = true;
                        this.HIDE_SNACKBAR();
                        await updatePassword(this.$firebaseAuth.currentUser, this.form.password);
                        this.SHOW_SNACKBAR_SUCCESS("Your password has been updated.")
                    }
                }
                catch (error)
                {
                    let errorMessage;
                    switch (error.code)
                    {
                        default:
                            errorMessage = 'System Error.';
                    }
                    this.SHOW_SNACKBAR_ERROR(errorMessage)
                }
                this.submitting = false;
                this.form.password = '';
                // You should call it on the next frame
                window.requestAnimationFrame(() =>
                {
                    this.$refs.observer.reset()
                });
            }
        }
    };
</script>

<style scoped>
</style>